import { createContext } from 'react'

const ShellRootContext = createContext(undefined)

export default ShellRootContext
